import React from "react";
import styled from "styled-components";
import { Flex } from "../common/design-system";
import Navigation from "../Navigation";

const Container = styled(Flex)`
  display: flex;
  min-height: 100vh;
  position: relative;
`;

const ContentWrapper = styled.div`
  flex: 1;
  overflow-x: hidden;
  margin-left: 272px;

  @media (max-width: 760px) {
    margin-left: 0;
    padding-top: 60px;
  }
`;

const Layout = ({ children }) => {
  return (
    <Container>
      <Navigation />
      <ContentWrapper>
        {children}
      </ContentWrapper>
    </Container>
  );
};

export default Layout;
